import { createContext, useContext, type ReactNode } from "react";

const StorefrontTenantContext = createContext<string | null>(null);

export function StorefrontTenantProvider({ slug, children }: { slug: string; children: ReactNode }) {
  return <StorefrontTenantContext.Provider value={slug}>{children}</StorefrontTenantContext.Provider>;
}

/** Store slug when browsing a tenant subdomain host; otherwise null. */
export function useStorefrontTenantSlug(): string | null {
  return useContext(StorefrontTenantContext);
}
